import { render, staticRenderFns } from "./SmallRoundedSelect.vue?vue&type=template&id=0127a0af&"
import script from "./SmallRoundedSelect.vue?vue&type=script&lang=ts&scoped=true&"
export * from "./SmallRoundedSelect.vue?vue&type=script&lang=ts&scoped=true&"
import style0 from "./SmallRoundedSelect.vue?vue&type=style&index=0&id=0127a0af&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports